"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        /**
         * Client implementation of X++ TaskGuideDocumentViewer control.
         * Used to visualize the Task Guide preview list in the Help Pane.
         */
        var TaskGuideDocumentViewer = /** @class */ (function (_super) {
            __extends(TaskGuideDocumentViewer, _super);
            function TaskGuideDocumentViewer() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            TaskGuideDocumentViewer.prototype.init = function (data, element) {
                var e_1, _a;
                _super.prototype.init.call(this, data, element);
                var tableElement = this.element.firstChild;
                // any is used as base dataSource of BoundDataSource type is not assignable to ModelCollection
                var modelCollection = $dyn.value($dyn.getModelCollection(this.DataSourceName, this.DataSource));
                // get the templates for the rows to be added to the document viewer table control.
                var taskTemplate = $dyn._getTemplate("TaskRowElement");
                var taskStepTemplate = $dyn._getTemplate("TaskStepRowElement");
                var stepTemplate = $dyn._getTemplate("StepRowElement");
                var isTaskActive = false;
                // Stores the top level numbering for steps that are not within a task.
                var stepNo = 1;
                // Stores the second level numbering for steps within tasks
                var taskStepNo = 1;
                try {
                    for (var modelCollection_1 = __values(modelCollection), modelCollection_1_1 = modelCollection_1.next(); !modelCollection_1_1.done; modelCollection_1_1 = modelCollection_1.next()) {
                        var model = modelCollection_1_1.value;
                        var step = $dyn.value($dyn.getFieldObservable("Step", model));
                        var isTask = $dyn.util.stringToBoolean($dyn.value($dyn.getFieldObservable("IsTask", model)));
                        var title = $dyn.value($dyn.getFieldObservable("AnnotationTitle", model));
                        var description = $dyn.value($dyn.getFieldObservable("AnnotationDescription", model));
                        // If task then create a  task node.
                        if (isTask) {
                            // Dont add a row for the end task but restart the numbering.
                            if (step && step.indexOf("End") !== -1) {
                                taskStepNo = 1;
                                isTaskActive = false;
                            }
                            else {
                                var $taskElem = $(taskTemplate).clone();
                                if ($taskElem) {
                                    $taskElem.find("span").text(step);
                                    $(tableElement).append($taskElem);
                                    $taskElem.find("td").addClass("taskGuideContent-taskStartRowElement");
                                    isTaskActive = true;
                                }
                            }
                        }
                        else {
                            var $stepElem = void 0;
                            if (title !== "") {
                                // If its a task, select the task step template else select the step template.
                                $stepElem = isTaskActive ? $(taskStepTemplate).clone() : $(stepTemplate).clone();
                                if ($stepElem && tableElement) {
                                    $stepElem.find("#StepRowNo").html((isTaskActive ? taskStepNo++ : stepNo++) + ".");
                                    $stepElem.find("span").text(title);
                                    $(tableElement).append($stepElem);
                                }
                            }
                            // If its a task, select the task step template else select the step template.
                            if (step !== "") {
                                $stepElem = isTaskActive ? $(taskStepTemplate).clone() : $(stepTemplate).clone();
                                if ($stepElem && tableElement) {
                                    $stepElem.find("span").text(step);
                                    if (title === "") {
                                        $stepElem.find("#StepRowNo").html((isTaskActive ? taskStepNo++ : stepNo++) + ".");
                                    }
                                    $(tableElement).append($stepElem);
                                }
                            }
                            if (description !== "") {
                                $stepElem = isTaskActive ? $(taskStepTemplate).clone() : $(stepTemplate).clone();
                                if ($stepElem && tableElement) {
                                    $stepElem.find("span").text(description);
                                    $(tableElement).append($stepElem);
                                }
                            }
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (modelCollection_1_1 && !modelCollection_1_1.done && (_a = modelCollection_1.return)) _a.call(modelCollection_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            };
            return TaskGuideDocumentViewer;
        }($dyn.ui.Control));
        controls.TaskGuideDocumentViewer = TaskGuideDocumentViewer;
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=TaskGuideDocumentViewer.js.map
